import { render } from "./OrganismsMapCharts.vue?vue&type=template&id=67b237e4&scoped=true&ts=true"
import script from "./OrganismsMapCharts.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsMapCharts.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsMapCharts.vue?vue&type=style&index=0&id=67b237e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b237e4"],['__file',"src/components/organisms/OrganismsMapCharts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67b237e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b237e4', __exports__)) {
    api.reload('67b237e4', __exports__)
  }
  
  module.hot.accept("./OrganismsMapCharts.vue?vue&type=template&id=67b237e4&scoped=true&ts=true", () => {
    api.rerender('67b237e4', render)
  })

}


export default __exports__